import {Injectable} from '@angular/core';
import {UpdateMetaTitleService} from '../../services/updateMetaTitle/update-meta-title.service';

@Injectable({
  providedIn: 'root',
})
export class MetaDataUtil {
  constructor(private updateMeta: UpdateMetaTitleService) {}

  updateMetaTitle(data: {title: string; pathName: string}, url: string) {
    this.updateMeta.updateMetaTitle(data, url);
  }
}
